import { generateSubsetSchema } from './generateJsonSchema';

function toPascalCase(str: string): string {
  return str
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');
}

export function generateOpenApiComponent(
  schema: object,
  selectedFields: string[],
  requiredOverrides: Record<string, boolean>,
  standardName: string,
  standardVersion: string
): object {
  const subsetSchema = generateSubsetSchema(schema, selectedFields, requiredOverrides);
  const schemaName = toPascalCase(standardName) + 'Subset';

  // Remove $schema as OpenAPI doesn't use it
  const { $schema, ...schemaWithoutDraft } = subsetSchema as Record<string, unknown>;

  return {
    openapi: '3.0.3',
    info: {
      title: `${standardName} Schema Component`,
      version: standardVersion,
      description: `Generated subset of the AutomotiveAPI ${standardName} standard`,
    },
    paths: {},
    components: {
      schemas: {
        [schemaName]: schemaWithoutDraft,
      },
    },
  };
}

export function generateOpenApiString(
  schema: object,
  selectedFields: string[],
  requiredOverrides: Record<string, boolean>,
  standardName: string,
  standardVersion: string
): string {
  const openApiDoc = generateOpenApiComponent(
    schema,
    selectedFields,
    requiredOverrides,
    standardName,
    standardVersion
  );
  return JSON.stringify(openApiDoc, null, 2);
}
